import ls from "local-storage";
import { getRemoteStorageProxy } from "../api/remoteStorage";

export function isTableTentMode(param_delivery_method_identifier) {
  let kiosk_options = get_kiosk_options();
  let video = "";
  let order_complete_actions = kiosk_options.order_complete_actions;
  if (order_complete_actions) {
    let o = order_complete_actions.find(
      e => e.delivery_method === param_delivery_method_identifier
    );
    if (o && typeof o.video !== "undefined") {
      video = o.video;
    }
  }
  return video === "table_tent";
}

export function get_kiosk_options() {
  let js_orderkiosk_options = {
    order_complete_actions: [
      {
        delivery_method: "to_stay",
        dispense_puck: true,
        show_qr_code: false,
        show_order_number: true,
        video: "buzzer_eat-in"
      },
      {
        delivery_method: "to_take",
        dispense_puck: true,
        show_qr_code: false,
        show_order_number: true,
        video: "buzzer_takeaway"
      },
      {
        delivery_method: "to_start",
        dispense_puck: false,
        show_qr_code: true,
        show_order_number: true,
        video: "orderscreen"
      }
    ]
  };
  if (typeof window.mmsKiosk !== "undefined") {
    if (
      typeof window.mmsKiosk.jsonConfig !== "undefined" &&
      typeof window.mmsKiosk.jsonConfig.getConfigValue !== "undefined"
    ) {
      js_orderkiosk_options = window.mmsKiosk.jsonConfig.getConfigValue(
        "js_orderkiosk_options"
      );
    }
  } else if (process.env.NODE_ENV === "development") {
    //TODO: make dev options when different from defaults
    js_orderkiosk_options["assortment_options"] = {
      enabled: true,
      show_hidden: false,
      url: process.env.VUE_APP_ASSORTMENT_OPTIONS_URL,
      apikey: process.env.VUE_APP_ASSORTMENT_OPTIONS_APIKEY,
      namespace: "assortment"
    };
  }
  return js_orderkiosk_options;
}

function localStorageNumberSystem() {
  return {
    increment(key) {
      let on = ls.get("kiosk-ordernumber");
      if (!on) {
        ls.set("kiosk-ordernumber", parseInt(Math.random() * 999 + 1));
        on = ls.get("kiosk-ordernumber");
      }
      on = (on + 1) % 999; //internal zero indexed
      ls.set("kiosk-ordernumber", on);
      return Promise.resolve(on + 1); //return 1 indexed
    },
    set(key, value) {
      return Promise.resolve(true);
    }
  };
}

export function getNumberSystem() {
  let number_system;
  if (typeof window.mmsKiosk !== "undefined") {
    if (
      typeof window.mmsKiosk.jsonConfig !== "undefined" &&
      typeof window.mmsKiosk.jsonConfig.getConfigValue !== "undefined"
    ) {
      number_system = window.mmsKiosk.jsonConfig.getConfigValue(
        "js_numbersystem"
      );
    } else {
      return null;
    }
  } else if (process.env.NODE_ENV === "development") {
    number_system = {
      type: process.env.VUE_APP_DEV_NUMBER_SYSTEM_TYPE,
      params: JSON.stringify({
        url: process.env.VUE_APP_DEV_NUMBER_SYSTEM_URL,
        apikey: process.env.VUE_APP_DEV_NUMBER_SYSTEM_APIKEY
      })
    };
  } else {
    return null;
  }
  if (number_system && number_system.type === "remotestorage") {
    let params = JSON.parse(number_system.params);
    let url, apikey;
    url = params.url;
    apikey = params.apikey;
    if (!url || !apikey) return null;
    return getRemoteStorageProxy(url, "order_numbers", apikey);
  } else if (number_system.type === "localstorage") {
    return localStorageNumberSystem();
  } else {
    return null;
  }
}

export function getAssortmentOptions() {
  let js_options = get_kiosk_options();
  if (js_options.assortment_options) {
    console.log(
      "getAssortmentOptions: " + JSON.stringify(js_options.assortment_options)
    );
    let rv = { ...js_options.assortment_options };
    if (rv.show_hidden === undefined) {
      rv.show_hidden = false;
    }
    return rv;
  } else {
    let default_assortment_options = { enabled: false, show_hidden: false };
    console.log(
      "getAssortmentOptions - options not set: " +
        JSON.stringify(default_assortment_options)
    );
    return default_assortment_options;
  }
}
